import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OrderNumberService {
order_number;
  constructor() { }
}
